import { InstanceScreen } from 'component/navigation/instance';

export default function AdminCreateVotingScreen() {
    return <InstanceScreen screenKey='createVoting' />;
}
